import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface SheathingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Sheathing: React.FC<SheathingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [sheathing, set_sheathing] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Framing']?.['Sheathing'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Framing': { ...b.values?.['Framing'], 'Sheathing': v } } })
    );
    const label = 'Sheathing (if not included above)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(sheathing)}
                />
            ) : (
                <MoneyBox
                    id={'sheathing'}
                    allowNegative={false}
                    value={sheathing}
                    onChange={(value) => set_sheathing(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
